module.exports = "/assets/data/7539ca36cce442e8eba750f5253b6f69-BA2.data.json";